import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconButtonSize, inlineTextIconMargin, media, modalPadding, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { Button, useTheme } from "@mui/material";
import React, { FunctionComponent, PropsWithChildren } from "react";

interface EmptyDashboardWidgetComponentProps {
    icon: IconProp;
    buttonText: string;
    onClick: () => void;
}

export const EmptyDashboardWidgetComponent: FunctionComponent<PropsWithChildren<EmptyDashboardWidgetComponentProps>> = ({ icon, children, buttonText, onClick }) => {
    const theme = useTheme<Theme>();

    return (
        <StyledContainer>
            <TextIconContainer>
                <IconContainer>
                    <FontAwesomeIcon icon={icon} style={{ color: theme.typographyColors.blank }} size="lg" />
                </IconContainer>
                {children}
            </TextIconContainer>
            <StyledButton variant="outlined" color="primary" onClick={onClick}>
                {buttonText}
            </StyledButton>
        </StyledContainer>
    );
};

const TextIconContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1 0;
    margin-bottom: ${inlineTextIconMargin};
`;

const StyledContainer = styled.div`
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.light20};
    display: flex;
    align-items: center;
    width: 100%;
    height: fit-content;
    padding: ${modalPadding};

    ${media.extraSmall} {
        display: block;
    }
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.grey};
    height: ${iconButtonSize};
    margin-right: ${inlineTextIconMargin};
    flex: 0 0 ${iconButtonSize};
`;

const StyledButton = styled(Button)`
    ${media.extraSmall} {
        width: 100%;
    }
`;
